/* template */
<template minapp="mpx" xlang="wxml"><div :style="[(notSale ? 'color: #999999' : '')] | transRpxStyle" class="card"><mpx-view @tap="chooseTrain" class="card-main"><div class="off-sale" v-if="(notSale)"><div class="off-sale-text">暂停发售</div></div><div :style="[(notSale ? 'alignItems: center' : '')] | transRpxStyle" class="card-item"><div class="train-info start"><div class="time" v-if="(!notSale)">{{ startTime }}</div><div class="sizebox"></div><div class="train-code start"><div :style="[(notSale ? 'color: #999999' : '')] | transRpxStyle" class="station-name">{{
              trainInfo.from_station_name
            }}</div><div class="station-dot from" v-if="(!isTransfer)">{{ trainInfo.is_start_station == 1 ? '始' : '过' }}</div></div></div><div :style="[(notSale ? 'flex: 2' : '')] | transRpxStyle" class="train-info center" v-if="(!isTransfer)"><div :style="[('color: #999999')] | transRpxStyle" class="station-info station-info-up" v-if="(notSale)">{{ notSaleMsg }}</div><div class="station-info station-info-up" v-else>{{ duration }}</div><mpx-image src="https://dpubstatic.udache.com/static/dpubimg/giRx8tUEEvhUyA8DGud3G.png" class="img"></mpx-image><div class="train-code"><div :style="[(notSale ? 'color: #999999' : '')] | transRpxStyle" class="station-info station-info-bottom">{{ trainInfo.train_code }}</div><div :style="[({marginLeft: '2px'})] | transRpxStyle" class="station-dot" v-if="(showSilent && !notSale)">静</div><div :style="[({marginLeft: '2px'})] | transRpxStyle" class="station-dot fuxing" v-if="(showFxh && !notSale)">复兴号</div><div :style="[({marginLeft: '2px'})] | transRpxStyle" class="station-dot zndc" v-if="(ShowZndc && !notSale)">智能动车</div></div></div><div :style='["flex: none"] | transRpxStyle' class="train-info center" v-else><div :style="[('color: #999999')] | transRpxStyle" class="station-info station-info-up transfer-top" v-if="(notSale)">{{ notSaleMsg }}</div><div class="station-info station-info-up transfer-top" v-else>{{ duration }}</div><div class="station-info station-info-up transfer-center"><div class="container"><mpx-image src="https://ut-static.udache.com/webx/sfc/0qPjtyLL21lQO8Nx3Jpqi.png" class="icon"/><span>{{ transferStation }}</span></div><mpx-image src="https://ut-static.udache.com/webx/sfc/99qi9qFGZ22U7XTX3jubR.png" class="img"></mpx-image></div><div class="station-info station-info-up transfer-bottom"><span :class="(isTransferDif && 'transfer-different')">{{ transferSameText }}</span><span>·{{ transferTime }}</span></div></div><div class="train-info arrive"><div class="time arrive" v-if="(!notSale)">{{ endTime }}<div class="day-diff" v-if="(trainInfo.day_difference > 0)">{{
              `+${trainInfo.day_difference}天`
            }}</div></div><div class="sizebox"></div><div class="train-code end"><div class="station-dot to" v-if="(!isTransfer)">{{ trainInfo.is_end_station == 1 ? '终' : '过' }}</div><div :style="[(notSale ? 'color: #999999' : '')] | transRpxStyle" class="station-name">{{
              trainInfo.to_station_name
            }}</div></div></div><div class="train-info price" v-if="(!notSale)"><div :style="[(isScramble ? 'marginTop: 13px' : '')] | transRpxStyle" class="train-code"><div class="price small" v-if="(!(sellOut && fromChangeTicket))">¥</div><div :style='["margin-right: 2px; "] | transRpxStyle'></div><div class="price noSeat" v-if="(sellOut && fromChangeTicket)">无票</div><div class="price large" v-else>{{ lowestPrice.displayedPrice }}<span class="start-text" v-if="(isStudentType && !isScramble)">起</span></div></div><div class="coupon-desc" v-if="(lowestPrice.couponDesc)">{{ lowestPrice.couponDesc }}</div><crossed-price prefix="官方" :price="(lowestPrice.originalPrice)" class="original-price" v-if="(isShowCrossedPrice)"/></div><div :style="[(iconStyle)] | transRpxStyle" class="scramble-choose-icon" v-if="(isScramble)"></div></div><template v-if="(!isTransfer)"><div class="halt-sales-tips" v-if="(notSaleNow || isPreScramble)"><mpx-rich-text :nodes="(saleMsg)"></mpx-rich-text></div><div class="sell-out-tips" v-else-if="(sellOut && !saleFlag && !fromChangeTicket)">车票已售罄，新人可享免费高速抢票</div><div class="grid-container" v-else><div v-for="(item, index) in (refactorTicketInfo)" :key="item.index" :class="(item.style)"><span>{{ item.seat_type_name }}</span><span :class="({'grab-ticket': item.ticket_num === '无票' && !fromChangeTicket})">{{
              ' ' + (item.ticket_num === '无票' && !fromChangeTicket ? '抢票' : item.ticket_num)
            }}</span></div></div></template><div v-else><div v-for="(train, index) in (transferTikcetArr)" :key="train.index" class="transfer-ticket-container"><div class="placeholder"><div class="train-no">{{ transferTrainInfo(train) }}</div></div><div class="transfer-seat-container"><div :class="({gray: item.ticket_num === '无票'})" v-for="(item, index) in (train.ticket_data)" class="transfer-seat">{{ `${getSeatName(item.seat_type_name)} ${item.ticket_num}` }}</div></div></div></div></mpx-view><recommend-ticket :trainInfo="(trainInfo)" :recommendTicket="(recommendTicket)" :recommendTicketDrawer="(recommendTicketDrawer)" v-if="(recommendTicket && !fromChangeTicket)"/></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m3ca59191"}'>
@import '~@/mixins/stylus/color.styl'

.card
  display flex
  flex-direction column
  background white
  padding 14px 16px
  border-radius 16px
  box-sizing border-box
  position relative
.card-main
  display flex
  flex-direction column
  flex 1
.off-sale
  position absolute
  top 0
  left 0
  opacity 1
  width 64px
  height 16px
  color #1473FF
  font-size 10px
  line-height 12px
  background url('https://dpubstatic.udache.com/static/dpubimg/ZpTeWWF_G73r15nbsLxG4.png')
  background-size cover
  background-repeat no-repeat
  &-text
    padding 2px 0 2px 12px
.card-item
  height 48px
  display flex
  flex-direction row
  justify-content space-between
.train-info
  display flex
  flex-direction column
  &.start
    flex 1
  &.arrive
    flex 1
    text-align right
  &.center
    flex 1
    align-items center
    margin-top 2px
  &.price
    flex 1
    text-align right
    align-items flex-end
  .coupon-desc
    border-radius 3px
    font-family PingFangS-Medium
    font-size 9px
    font-weight normal
    line-height 9px
    margin 6px 0 2px
    color #FF6400
    border 0.5px solid #FFBC91
    padding 1.5px
  .original-price
    font-family PingFangSC-Medium
    font-weight 400
    font-size 9px
    color #999
  .transfer-top
    font-size 9px
    line-height 9px
    margin-top -3.5px
    margin-bottom 3px
  .transfer-center
    position relative
    display flex
    align-items center
    font-family PingFangSC-Medium
    font-size 11px
    font-weight 500
    line-height 11px
    text-align center
    border-radius 8px
    color #222
    .container
      display flex
      align-items center
      position relative
      background #fff
      padding 2.5px 6px
      z-index 2
      .icon
        height 9px
        width 8px
        margin-right 2px
      &::after
        position absolute
        content ''
        width 200%
        height 200%
        box-sizing border-box
        border 1px solid #ccc
        transform-origin 0 0
        transform scale(0.5)
        border-radius 8px
        top 0
        left 0
    .img
      width 100.5px
      height 3.5px
      position absolute
      top 50%
      left 50%
      transform translate(-50%, calc(-50% - 1px))
      z-index 1
  .transfer-bottom
    font-family PingFangSC-Regular
    font-size 9px
    font-weight 400
    line-height 9px
    display flex
    align-items center
    color #666
    margin-top 2.5px
    .transfer-different
      font-weight 500
      font-family PingFangSC-Medium
      color #333
.time
  font-size 22px
  color $train-color-333
  font-family Barlow Semi Condensed
  font-weight 400
  &.start
    font-size 22px
  &.arrive
    position relative
.day-diff
  position absolute
  font-size 11px
  right -25px
  top -4px
  color $train-color-666
.price
  color #FF6400
  font-weight 400
  font-family Barlow Semi Condensed
  &.large
    font-size 22px
  &.small
    font-size 14px
  &.noSeat
    font-size 16px
    color #BBBBBB
.station-name
  font-size 14px
  color $train-color-333
  font-family PingFangSC
.station-info
  font-size 11px
  color $train-color-666
  line-height 11px
  &-up
    margin-top 4.5px
    margin-bottom 5px
  &-bottom
    margin-top 5px
.train-code
  display flex
  flex-direction row
  align-items baseline
  min-height 20px
  &.start
    justify-content flex-start
    align-items center
  &.end
    justify-content flex-end
    align-items center
  .start-text
    font-size 11px
    margin-left 1px
    position relative
    top -1px
.silent
  background RGB(20, 115, 255, 0.1)
  font-size 8px
  font-weight 700
  color #438FFF
  border-radius 2px
  width 12px
  height 12px
  line-height 10px
  text-align center
  align-self center
  box-sizing border-box
  margin-left 2px
.station-dot
  border-radius 3px
  text-align center
  border 0.5px solid #CCCCCC
  // padding 1.5px
  width 11px
  height 11px
  text-align center
  line-height 12px
  font-size 9px
  color #888888
  &.from
    margin-left 3px
  &.to
    margin-right 3px
  &.fuxing
    width 30px
  &.zndc
    width 40px
.grid-container
  display grid
  grid-template-columns repeat(4, 1fr)
  margin-top 16px
  .grab-ticket
    color #FF4129
.ticket-style-1
  text-align center
.ticket-style-2
  text-align right
.ticket
  font-size 12px
  &.noTicket
    color $train-color-999
  &.hasTicket
    color $train-color-333
.sizebox
  height 6px
.img
  width 68px
  height 3px
.halt-sales-tips
  font-size 11px
  color #333333
  margin-top 10px
.sell-out-tips
  font-family PingFangSC-Regular
  font-size 11px
  line-height 13px
  color #FF4129
  margin-top 20px
.scramble-choose-icon
  width 19px
  height 19px
  background var(--icon-url)
  background-size cover
  background-repeat no-repeat
  margin 17px 4px 0 20px
.transfer-ticket-container
  display flex
  align-items flex-start
  margin-bottom 8px
  &:first-child
    margin-top 17px
  &:last-child
    margin-bottom 2px
  .placeholder
    min-width 50px
    margin-right 16px
    display flex
    .train-no
      padding 1.5px 2px
      background #F2F6F9
      border-radius 3px
      font-weight 400
      font-size 9px
      line-height 9px
      color #888
  .transfer-seat-container
    flex 1
    display grid
    grid-template-columns repeat(auto-fill, minmax(25%, 1fr))
    grid-row-gap 8px
    .transfer-seat
      font-size 11px
      font-weight 400
      line-height 11px
      white-space nowrap
      color #666
      &.gray
        color #999
      .seat-type
        margin-right 4px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m3ca59191"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./train-info-card.mpx.js?isComponent&outputPath=components%2Ftrain-info-card3ca59191%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./train-info-card.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Ftrain-info-card3ca59191%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m3ca59191"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/train-info-card3ca59191/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-icon':getComponent(require("../../../../node_modules/@didi/es-mpx-ui/lib/icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex")),'recommend-ticket':getComponent(require("../../../components/recommend-ticket/index.mpx?isComponent&outputPath=components%2Findexe4675b46%2Findex")),'crossed-price':getComponent(require("../../../components/crossed-price/index.mpx?isComponent&outputPath=components%2Findex1220e10f%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-rich-text':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-rich-text.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
